import { memo, useMemo } from 'react'
import { Team } from 'types/teams'
import { Table, Space, Popconfirm, Image } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { ExpandableRow } from './expandable-row'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: Team[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const TeamsTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<Team> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '',
                key: 'logo',
                render: (_, record) => {
                    return <Image height={40} width={40} src={record.logo} preview={false} />
                },
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Short name',
                dataIndex: 'short_name',
                key: 'short_name',
            },
            {
                title: 'Founded',
                dataIndex: 'founded_year',
                key: 'founded_year',
                render: (_, record) => record.founded_year ?? '—',
            },
            {
                title: 'Contacts',
                dataIndex: 'contacts',
                key: 'contacts',
            },
            {
                title: 'Instagram',
                dataIndex: 'instagram',
                key: 'instagram',
                render: (_, record) => record.instagram ?? '—',
            },
            {
                title: 'Telegram',
                dataIndex: 'telegram',
                key: 'telegram',
                render: (_, record) => record.telegram ?? '—',
            },
            {
                title: 'Logo',
                dataIndex: 'logo',
                key: 'logo',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete team', record.name)}
                            description={'Are you sure to delete this team?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return (
        <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            rowKey='id'
            pagination={false}
            expandable={{
                expandedRowRender: record => {
                    return <ExpandableRow data={record.teamsToTeamsRatings} />
                },
                rowExpandable: record => !!record.teamsToTeamsRatings.length,
            }}
        />
    )
})
